import {
	Component
} from '@angular/core'

@Component({
	selector: 'refer-complete',
	templateUrl: '../views/refer-complete.component.html'
})

export class ReferCompleteComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/refer-complete.component.ts